import {Col, CustomInput, FormGroup, Row} from "reactstrap";
import React from "react";

const CheckBoxRow = props => {
    const {label, id, name, checked, onChange, required} = props;
    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup>
                    <CustomInput
                        className="custom-checkbox"
                        type="checkbox"
                        id={id}
                        name={name}
                        label={label}
                        checked={checked}
                        onChange={onChange}
                        required={required}
                    />
                </FormGroup>
            </Col>
        </Row>
    )
}

export default CheckBoxRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/CheckBoxRow.js